import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-custom dialog-custom__content"
}
const _hoisted_2 = { class: "dialog-custom__footer mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThermostatPreferences = _resolveComponent("ThermostatPreferences")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom dialog-thermo-object-settings",
    style: {"min-width":"1000px"}
  }, {
    default: _withCtx(() => [
      (_ctx.roomObject)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_ElScrollbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ThermostatPreferences, { "room-object": _ctx.roomObject }, null, 8, ["room-object"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("footer", _hoisted_2, [
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button--m",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Close")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}